import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18next
  .use(Backend) // Load translations via HTTP
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18next to react-i18next
  .init({
    fallbackLng: 'en', // Fallback language
    debug: true, // Enable debug mode for development
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Path to your translation files
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'], // Detection order
      caches: ['cookie'], // Cache the detected language in cookies
    },
  });

export default i18next;